// extracted by mini-css-extract-plugin
export default {"icon":"Button_icon__zGldr","badge":"Button_badge__zAeAO","status":"Button_status__7od6k"};